/**
 *
 * ListFilters
 *
 */
// import styled from 'styled-components';

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import React from 'react'

// import { FormattedMessage } from 'react-intl';
// import messages from './messages';
import Icon from '../Icon'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    // margin: `0 ${theme.spacing(4)} 0`,
  },
  stgInput: {
    // padding: `${theme.spacing(4)} 0 0 0`,

    '&>div': {
      width: '100%',
    },
    '& input': {
      // border: '1px solid #ccc',
      // borderRadius: '3px',
      // padding: '10px',
      backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
    },
    '& :before': {
      // content: 'unset'
    },
    '& :after': {
      // content: 'unset'
    },
  },
  stgLabel: {
    margin: `0  0 ${theme.spacing(4)} 0`,
    position: 'inherit',
    // transform: 'translate(0, 27.5px) scale(0.75)',
  },
  mandatory: {
    color: theme.status.errorColor,
    lineHeight: 'unset',
  },
  errorP: {
    marginBottom: theme.spacing(4),
  },
  marginTopOneRem: {
    marginTop: theme.spacing(4),
  },
  locked: {
    pointerEvents: 'none',
  },
  positionLeft: {
    position: 'absolute',
    right: 0,
    bottom: '4px',
  },
  positionRelative: {
    position: 'relative',
  },
})

/* eslint-disable react/prefer-stateless-function */
class CustomWithLabel extends React.Component {
  render() {
    const {
      helperText,
      classes,
      ContainterStyle,
      label,
      value,
      isMandatory,
      onChange,
      isError,
      errorMessage,
      locked,
      children,
      // eslint-disable-next-line no-unused-vars
      // biome-ignore lint/correctness/noUnusedVariables: TODO
      ...rest
    } = this.props
    // const { filterData, selected } = this.state;
    return (
      <FormControl
        fullWidth
        className={classes.margin}
        // eslint-disable-next-line no-return-assign
        innerRef={node => (this.formControlNode = node)}
        error={isError}
      >
        {label ? (
          <InputLabel shrink={false} htmlFor={label} className={classes.stgLabel}>
            {label} {isMandatory && <span className={classes.mandatory}>*</span>}
          </InputLabel>
        ) : (
          ''
        )}
        <div className={cn(classes.stgInput, locked ? classes.locked : null, label ? classes.marginTopOneRem : null)}>
          {children}
        </div>
        {locked && (
          <div className={classes.positionRelative}>
            <Icon iconSize={15} iconName="lock" color="grey" className={cn(classes.iconLeft, classes.positionLeft)} />
          </div>
        )}
        {helperText && (
          <FormHelperText className={classes.errorP} id={`${label}-error-text`}>
            {' '}
            {isError && errorMessage}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
}

CustomWithLabel.defaultProps = {
  isMandatory: false,
  isError: false,
  errorMessage: 'Invalid value',
  helperText: true,
}

export default withStyles(styles)(CustomWithLabel)
